import type { DocBridgeConfigV1 } from '../config/schema.js'
import type { KnowledgeEntry } from '../schemas/doc-bridge-index.js'

export const renderLlmsTxt = (
  config: DocBridgeConfigV1,
  knowledge: readonly KnowledgeEntry[],
  projectName: string,
): string => {
  const preamble =
    config.index?.llmsTxt?.preamble ??
    `# ${projectName}\n\n> Agent-readable documentation index generated by ak-docs (@agentskit/doc-bridge).\n`

  const lines = knowledge.slice(0, 500).map((entry) => {
    const desc = entry.description ? `: ${entry.description}` : ''
    return `- [${entry.title}](${entry.path})${desc}`
  })

  return `${preamble.trim()}\n\n## Knowledge\n\n${lines.join('\n')}\n`
}